<template>
    <div class="car-status">      
      <div class="car-status-bottom">
        <div class="jiegou-input">
          <span class="trend-title">空闲车辆</span>
          <el-input type="number" placeholder="请输入" v-model="statusData.idleNum">
            <template slot="suffix">台</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">装货车辆</span>
          <el-input type="number" placeholder="请输入" v-model="statusData.loadingNum">
            <template slot="suffix">台</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">卸货车辆</span>
          <el-input type="number" placeholder="请输入" v-model="statusData.cargoNum">
            <template slot="suffix">台</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">在途车辆</span>
          <el-input type="number" placeholder="请输入" v-model="statusData.afloatNum">
            <template slot="suffix">台</template>
          </el-input>
        </div>
        <div class="jiegou-input">
          <span class="trend-title">返回车辆</span>
          <el-input type="number" placeholder="请输入" v-model="statusData.returnNum">
            <template slot="suffix">台</template>
          </el-input>
        </div>
      </div>


      <div style="margin-top:1rem" class="car-statu">
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">车辆编号（车牌号）</span>
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">状态</span>
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">车辆品牌型号</span>
        <span style="border-right:1px solid blue;width:10rem" class="trend-title">载重/人量</span>
        <span style="width:10rem" class="trend-title">驾驶人</span>
        <!-- <el-button @click="addCar" style="margin-left:1rem" type="primary" icon="el-icon-plus"></el-button> -->
        <i @click="addCar" class="el-icon el-icon-circle-plus-outline f_green" style="margin-top:10px"></i>
      </div>
      <div v-for="(item,index) in carDate" :key="index" class="car-statu">
        
          <el-input type="text" v-model="item.carNum"></el-input>
          <el-select v-model="item.status" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <el-input type="text" v-model="item.carBand"></el-input>
          <el-input type="text" v-model="item.carLoad"></el-input>
          <el-input type="text" v-model="item.driver"></el-input>
          <!-- <el-button @click="removeCar(item.id,index)" style="margin-left:1rem" type="primary" icon="el-icon-minus"></el-button> -->
          <i @click="removeCar(item.id,index)" class="el-icon el-icon-remove-outline f_red"></i>
      </div>
      <div class="last-save">
         <el-button :loading="statusLoading" size="small" @click="saveStatu" type="primary">保存</el-button>
      </div>
    </div>
</template>

<script>
import api from '@/apis/transportation/transportation'
export default {
  data() {
    return {
      statusLoading:false,//加载状态
      options: [{
        value: 1,
        label: '空闲'
      }, {
        value: 2,
        label: '装货'
      }, {
        value: 3,
        label: '在途'
      }, {
        value: 4,
        label: '卸货'
      }, {
        value: 5,
        label: '返回'
      }],
      
      statusData:{
        idleNum:'',//空闲车辆
        loadingNum:'',//装货车辆
        cargoNum:'',//卸货车辆
        afloatNum:'',//在途车辆
        returnNum:'',//返回车辆
      },
      
      carDate:[
        {carNum:'',status:'',carBand:'',carLoad:'',driver:''}
      ]
    }
  },
  mounted() {
    this.getStatu()
  },
  methods: {
    //保存数据
    saveStatu(){
      this.statusLoading = true;
      let obj = {}
      obj.stateSize = this.statusData;
      obj.states = this.carDate;
      api.saveCarState(obj).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.getStatu()
          this.statusLoading = false;
        }else{
          this.$message.error(res.message);
          this.statusLoading = false;    
          return;     
        }
      })
    },
    //获取数据
    getStatu(){
      api.getCarState('').then(res=>{
        if(res.code==10000){
          if(res.data.list.length!=0){
            this.carDate = res.data.list
          }else{
            this.carDate = [
              {carNum:'',status:'',carBand:'',carLoad:'',driver:''}
            ]
          }
        }
      })
      api.getCarStateList().then(data=>{
        if(data.code==10000){
          if(data.data.length!=0){
            this.statusData = data.data[0]
          }
        }
      })
    },
    //删除一行车辆
    removeCar(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          api.delCarState([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getStatu()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.carDate.splice(index,1)
      }
    },
    //增加一行车辆
    addCar(){
      this.carDate.push({carNum:'',status:'',carBand:'',carLoad:'',driver:''})
    },
  }
}
</script>
<style lang="less" scoped>
.car-status{ padding-top: 10px;
  .jiegou-input{ display: inline-block; margin-right: 15px;
    .el-input{ width: 8rem;}
  }
  .car-statu{
    .trend-title{ text-align: center;}
    .el-input,.el-select{ width: 10rem;}
    i{ font-size: 1.2rem; font-weight: bold; margin-left: 1rem; vertical-align: middle;}
  }
}
</style>

